export default function authHeader() {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");

    return {
      "X-Client-Type": "web",
      ...(user?.accessToken && {
        Authorization: `Bearer ${user.accessToken}`,
      }),
    };
  } catch (e) {
    return { "X-Client-Type": "web" };
  }
}
